<template>
  <div :class="[baseCss, dense ? 'text-xs' : 'text-sm']" role="tree">
    <transition name="slide">
      <ul>
        <treeview-item
          @node-click="$emit('node-click', $event)"
          :show-file-icon="showFileIcon"
          :items="items"
          :dense="dense"
          :icon-color="iconColor"
          :icon-color-lightness="iconColorLightness"
          :file-icon="fileIcon"
          :icon-provider="iconProvider"
          :folder-open="folderOpen"
          :checkboxes="checkboxes"
          :folder-closed="folderClosed" />
      </ul>
    </transition>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'
import TreeviewItem from './treeview-item'

export default {
  name: 'Treeview',
  components: {
    TreeviewItem
  },
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('treeview', ['select-none'])
    }
  },
  props: {
    items: {
      type: Object,
      required: true
    },
    folderOpen: {
      type: String,
      default: 'folder-open'
    },
    folderClosed: {
      type: String,
      default: 'folder'
    },
    fileIcon: {
      type: String,
      default: 'file'
    },
    iconColor: {
      type: String
    },
    iconColorLightness: {
      type: Number,
      default: null
    },
    showFileIcon: {
      type: Boolean,
      default: true
    },
    checkboxes: {
      type: Boolean
    },
    dense: {
      type: Boolean
    }
  }
}
</script>
<style>
.bcq-treeview li
{
  padding: 0 0 0 21px;
}

.bcq-treeview > ul > li
{
  padding-left: 0;
}

.bcq-treeview .bcq-treeview-item-label-no-file-icon
{
  padding-left: 9px;
  line-height: 29px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/treeview/treeview.vue